<template>
  <component :is="currentComponent"></component>
</template>

<script>
import ContentEn from './EducationContent/ContentEn.vue';
import ContentPtBR from './EducationContent/ContentPtBR.vue';
import ContentEs from './EducationContent/ContentEs.vue';
import { LANGUAGES } from '@/common/constants';

export default {
  props: {
    language: {
      type: String,
      default: LANGUAGES.EN
    }
  },
  computed: {
    currentComponent() {
      if (this.language === LANGUAGES.PT_BR) {
        return ContentPtBR;
      }
      if (this.language === LANGUAGES.ES) {
        return ContentEs;
      }
      return ContentEn;
    }
  }
};
</script>

<style scoped>
</style>
